import "./styles/typography.css";
import "./styles/base.css";
import { initPetalScene, type PetalScene } from "./scene/petals";
import { initMotion } from "./motion";

function initHero(): PetalScene | null {
	const canvas = document.getElementById(
		"hero-canvas",
	) as HTMLCanvasElement | null;
	if (!canvas) return null;

	const scene = initPetalScene(canvas);
	if (!scene) {
		document.body.classList.add("no-webgl");
		return null;
	}

	const parent = canvas.parentElement!;
	const onResize = () => {
		const r = parent.getBoundingClientRect();
		scene.resize(r.width, r.height);
	};
	window.addEventListener("resize", onResize);

	const onPointer = (e: PointerEvent) => {
		const nx = (e.clientX / window.innerWidth) * 2 - 1;
		const ny = -((e.clientY / window.innerHeight) * 2 - 1);
		scene.setMouse(nx, ny);
	};
	window.addEventListener("pointermove", onPointer, { passive: true });

	// Wind gust on scroll
	let lastScrollY = window.scrollY;
	let gustCooldown = 0;
	const onScroll = () => {
		const now = performance.now();
		if (now < gustCooldown) return;
		const dy = Math.abs(window.scrollY - lastScrollY);
		lastScrollY = window.scrollY;
		if (dy > 40) {
			scene.gust(1.6, 600);
			gustCooldown = now + 700;
		}
	};
	window.addEventListener("scroll", onScroll, { passive: true });

	// Petal burst on CTA hover
	const ctas = document.querySelectorAll<HTMLElement>("[data-hero-cta]");
	ctas.forEach((cta) => {
		cta.addEventListener("mouseenter", (e) => {
			const me = e as MouseEvent;
			const world = scene.canvasToWorld(me.clientX, me.clientY);
			scene.emitBurst(world.x, world.y, 15);
		});
	});

	return scene;
}

function wireCalculator(): void {
	const select = document.getElementById(
		"calc-turnover",
	) as HTMLSelectElement | null;
	if (!select) return;
	const computeRecovery = (turnover: number): number => {
		const abandonRate = 0.7;
		const recoveryUplift = 0.18;
		return Math.round(turnover * abandonRate * recoveryUplift);
	};
	const update = () => {
		const turnover = Number(select.value);
		const recovery = computeRecovery(turnover);
		const updateFn = (
			window as unknown as { __calcUpdate?: (n: number) => void }
		).__calcUpdate;
		updateFn?.(recovery);
	};
	select.addEventListener("change", update);
	queueMicrotask(update);
}

window.addEventListener("DOMContentLoaded", () => {
	initHero();
	initMotion();
	wireCalculator();
});
